import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

/**
 * Make the default bootstrap accordion component more accessible
 */
export default class AccordionCardHeader extends BaseComponent {
    connected() {
        this.element.setAttribute('role', 'button');
        this.element.setAttribute('tabindex', '0');
    }

    events() {
        return {
            this: {
                // we don't need to register click event as it already has been registered by bootstrap (collapse plugin)
                keydown: (event) => {
                    // The action button is activated by space on the keyup event, but the
                    // default action for space is already triggered on keydown. It needs to be
                    // prevented to stop scrolling the page before activating the button.
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                    // If enter is pressed, activate the button
                    else if (event.keyCode === 13) {
                        event.preventDefault();
                        this.element.click();
                    }
                },
                keyup: (event) => {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                        this.element.click();
                    }
                },
            },
        };
    }
}

defineComponent('accordion-card-header', AccordionCardHeader);
